@if (filtrationForm && availableInvestments) {
  <div class="transactions-container">
    <div class="header-layout">
      <div class="transactions-header">
        {{ 'money.transactionsHistoryHeader' | translate }}
      </div>
      <div
        (click)="openExportModal()"
        (keydown.space)="openExportModal()"
        (keydown.enter)="openExportModal()"
        tabindex="0"
        class="export-icon"
      >
        <svg-icon src="assets/icons/file-arrow-down.svg" [svgStyle]="{ 'width.px':25 }"></svg-icon>
      </div>
    </div>
    <div class="transaction-filtrations-container">
      <div class="row g-0">
        <div class="col-12 col-lg-6">
          @if (preloaders.investments) {
            <libero-preload-spinner></libero-preload-spinner>
          } @else {
            <div class="row">
              <div class="col-4 filtration-label">
                {{ 'money.portfolio' | translate }}
              </div>
              @if (!preloaders.investments) {
                <div class="col-8 filtration-dropdown" data-cy="portfolio-transaction-filter">
                  <libero-dropdown
                    [availableList]="availableInvestments"
                    (itemSelected)="valueUpdated($event, 'portfolio')"
                    [itemSelectedControl]="filtrationForm.controls['investment']"
                    [initialValue]="initialInvestment"
                  ></libero-dropdown>
                </div>
              }
            </div>
          }
        </div>
        <div class="col-12 col-lg-6">
          <div class="row mt-3 mt-lg-0">
            <div class="col-4 filtration-label">
              {{ 'money.term' | translate }}
            </div>
            <div class="col-8" data-cy="term-transaction-filter">
              <libero-dropdown
                [displaySelectAllOption]="false"
                [availableList]="availablePeriods"
                (itemSelected)="valueUpdated($event, 'term')"
                [itemSelectedControl]="filtrationForm.controls['periods']"
                [initialValue]="allPeriodsItem"
                [allPlaceholder]="allPeriodsItem"
              ></libero-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="checkboxes-container">
      <div class="row">
        @for (checkbox of filtrationForm.controls['checkboxes'].value; track checkbox.name) {
          <div
            class="col-4 col-md-3 col-xl-2 filtration-checkbox"
            [attr.data-cy]="'transaction-filtration-checkbox ' + checkbox.apiKey"
            >
            <label class="container" for="{{checkbox.name}}">
              <input id="{{checkbox.name}}" type="checkbox" name="{{checkbox.name}}" [(ngModel)]="checkbox.value" (ngModelChange)="updateCheckboxAndData()">
              <span class="checkmark"></span>
              {{ checkbox.name }}
            </label>
          </div>
        }
      </div>
    </div>
    @if (showMarkAllBtn) {
      <div
        class="clear-filtrations"
        (click)="markAll()"
        data-cy="transactions-mark-all"
        (keydown.space)="markAll()"
        (keydown.enter)="markAll()"
        tabindex="0"
        >
        {{ 'money.markAll' | translate }}
      </div>
    } @else {
      <div
        class="clear-filtrations"
        (click)="markAll(false)"
        data-cy="transactions-unmark-all"
        (keydown.space)="markAll(false)"
        (keydown.enter)="markAll(false)"
        tabindex="0"
        >
        {{ 'money.unmarkAll' | translate }}
      </div>
    }
    @if (preloaders.transactions) {
      <libero-preload-spinner></libero-preload-spinner>
    } @else if (availableFilteredTransactions) {
      <div class="transaction-list">
        <hr class="divider">
        @for (transaction of transactions | paginate: paginationConfig; track transaction.transactionId) {
          <div class="transaction-list-item" [attr.data-cy]="'transaction-list-item ' + transaction.type + '_' + transaction.direction">
            <div class="transaction-icon-container">
              <svg-icon
                [src]="mappedTransactionIcons[(transaction.type ?? transaction.uiType) + '_' + transaction.direction] ?? unknownTypeIconPath"
                [attr.data-cy]="mappedTransactionIcons[(transaction.type ?? transaction.uiType) + '_' + transaction.direction] ?? unknownTypeIconPath"
                [svgStyle]="{ 'width.px':29 }"
              ></svg-icon>
            </div>
            <div class="transaction-detail">
              <div
                class="transaction-parent"
                [ngClass]="{'transaction-parent--disabled': !transaction.portfolio.accessible}"
                (click)="redirectToPortfolio(transaction)"
                (keydown.space)="redirectToPortfolio(transaction)"
                (keydown.enter)="redirectToPortfolio(transaction)"
                data-cy="transaction-detail-header"
                tabindex="0"
              >
                {{ transaction.portfolio.name }}
              </div>
              <div class="transaction-description" data-cy="transaction-description">
                @if (transaction.type !== 'OPF_MANAGEMENT_FEE_REFUND') {
                  @if (transaction.type !== 'ORDER') {
                    {{ transaction.description }}
                  } @else {
                    {{ 'money.transactionTypes.' + transaction.uiType | translate }}
                    &ndash;
                    {{ transaction.instrument.isin }}
                    &ndash;
                    {{ transaction.quantity }} {{ 'money.pieces' | translate }}
                  }
                } @else {
                  {{ 'money.refundDescription' | translate }}
                }
              </div>
              <div class="transaction-date-desktop">
                {{ transaction.transactionTimestamp | date:'d. M. y' }}
              </div>
              <div class="transaction-date-phone">
                <div class="transaction-date">
                  {{ transaction.transactionTimestamp | date:'d. M. y' }}
                </div>
                @if (transaction.vat > 0) {
                  <div class="transaction-amount" data-cy="transaction-amount">
                    {{ transaction.amount | transactionPrice:transaction.instrument.currencyCode:'cs-CZ' }}
                  </div>
                }
              </div>
              <div class="transaction-footer-phone" data-cy="transaction-footer-phone">
                <div class="transaction-type"data-cy="transaction-type">
                  {{ 'money.transactionTypes.' + transaction.uiType | translate }}
                </div>
                @if (transaction.vat === 0) {
                  <div class="transaction-amount" data-cy="transaction-amount">
                    {{ transaction.amount | transactionPrice:transaction.instrument.currencyCode:'cs-CZ' }}
                  </div>
                }
                @if (transaction.vat > 0) {
                  <div class="transaction-vat" data-cy="transaction-vat">
                    {{ 'money.includingVAT' | translate }}{{ transaction.vat | transactionPrice:transaction.instrument.currencyCode:'cs-CZ' }}
                  </div>
                }
              </div>
            </div>
            <div class="transaction-footer-desktop" data-cy="transaction-footer-desktop">
              <div class="transaction-type" data-cy="transaction-type">
                {{ 'money.transactionTypes.' + transaction.uiType | translate }}
              </div>
              <div class="transaction-amount" data-cy="transaction-amount">
                {{ transaction.amount | transactionPrice:transaction.instrument.currencyCode:'cs-CZ' }}
              </div>
              @if (transaction.vat > 0) {
                <div class="transaction-vat" data-cy="transaction-vat">
                  {{ 'money.includingVAT' | translate }}{{ transaction.vat | transactionPrice:transaction.instrument.currencyCode:'cs-CZ' }}
                </div>
              }
            </div>
          </div>
          <hr class="divider">
        }
        <div class="pagination-container">
          <pagination-template #p="paginationApi" class="pagination-custom-control" [id]="paginationConfig.id!">
            <div
              data-cy="transaction-prev-page"
              class="pagination-arrow pagination-previous "
              [ngClass]="{ 'pagination-arrow--inactive': !prevPageAvailable() }"
              >
              <a
                (click)="loadPrevPage()"
                (keydown.space)="loadPrevPage()"
                (keydown.enter)="loadPrevPage()"
                tabindex="0"
                >
                <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(90deg)' }"></svg-icon>
              </a>
            </div>
            @for (page of p.pages; track page.value) {
              <div [class.current]="p.getCurrent() === page.value">
                @if (p.getCurrent() !== page.value) {
                  <a
                    (click)="goToPage(page.value)"
                    class="inactive-page"
                    (keydown.space)="goToPage(page.value)"
                    (keydown.enter)="goToPage(page.value)"
                    tabindex="0"
                    >
                    <span>{{ page.label }}</span>
                  </a>
                }
                @if (p.getCurrent() === page.value) {
                  <div class="current-page">
                    <span>{{ page.label }}</span>
                  </div>
                }
              </div>
            }
            <div
              data-cy="transaction-next-page"
              class="pagination-arrow pagination-next "
              [ngClass]="{ 'pagination-arrow--inactive': !nextPageAvailable() }"
              >
              <a
                (click)="loadNextPage()"
                (keydown.space)="loadNextPage()"
                (keydown.enter)="loadNextPage()"
                tabindex="0"
                >
                <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(270deg)' }"></svg-icon>
              </a>
            </div>
          </pagination-template>
        </div>
      </div>
    } @else {
      <hr class="divider mt-4">
      <!-- todo - styling + split no data at all / no data after filtrations -->
      <div class="no-data-container" data-cy="no-filtered-transactions">
        {{ 'global.error.noData' | translate }}
      </div>
      <hr class="divider">
    }
  </div>
} @else {
  <libero-preload-spinner></libero-preload-spinner>
}

